import { cn } from '@shared/lib/cn';

import { POPOVER_SKELETON_WIDTH_CLASS } from './popover.constant';

export interface PopoverSkeletonProps {
  className?: string;
}

/** Popover 의 status=init — 상자 안 내용 자리에 12 높이 막대 3줄(마지막 줄 60%) */
export function PopoverSkeleton({ className }: PopoverSkeletonProps) {
  return (
    <span
      aria-hidden="true"
      data-status="init"
      className={cn(
        'skeleton-pulse',
        'flex max-w-full flex-col gap-2',
        POPOVER_SKELETON_WIDTH_CLASS,
        className,
      )}
    >
      <span className="h-3 w-full rounded-full bg-bg-pressed" />
      <span className="h-3 w-full rounded-full bg-bg-pressed" />
      <span className="h-3 w-3/5 rounded-full bg-bg-pressed" />
    </span>
  );
}
